/**
 * Extract a tx hash from whatever the user pasted.
 * Accepts:
 *   - raw 66-char hash: 0xabc...def
 *   - full explorer URL: https://basescan.org/tx/0xabc...def
 *   - explorer URL with query/fragment: ...?v=1#…
 *   - messy input with surrounding whitespace or quotes
 * Returns the normalized 0x + 64 hex hash, or null if none found.
 */
export function extractTxHash(input) {
  if (!input) return null;
  const cleaned = String(input).trim().replace(/^["']|["']$/g, '');
  // Match the first 0x followed by exactly 64 hex chars (word boundary safe)
  const m = cleaned.match(/0x[0-9a-fA-F]{64}/);
  if (!m) return null;
  return m[0].toLowerCase();
}

export function isValidTxHash(h) {
  return typeof h === 'string' && /^0x[0-9a-fA-F]{64}$/.test(h);
}
